import React from 'react';

import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import calendarConst from 'FielderUtils/roleManagementConst/calendarConst';
import { useSelector } from 'react-redux';

import { ENDPOINTS } from '../../../../core/constants/pageEndpoints.constants';
import { selectValidPages } from '../../../../core/store/modules/session/sessionSelectors';

const CalendarSideMenu = ({ goToPage }) => {
	const lan = useLanguage();
	const title = lan.calendar;
	const validPages = useSelector(selectValidPages);

	return (
		<>
			{validPages && validPages[calendarConst.PAGE_NAME] && validPages[calendarConst.PAGE_NAME].isAllowed ? (
				<Tooltip title={title} placement='right'>
					<ListItemButton onClick={goToPage(ENDPOINTS.calendar)}>
						<ListItemIcon>
							<img className='' src={`${process.env.AWS_FIELDER_ICONS}calendar-icon.svg`} alt='calendar' />
						</ListItemIcon>
						<ListItemText primary={title} />
					</ListItemButton>
				</Tooltip>
			) : null}
		</>
	);
};

export default CalendarSideMenu;
